import React, { Component } from 'react';
import { StateContext } from '../Store/state-context';
import './Cookie.css';
import { Link } from 'react-router-dom';
class Cookie extends Component {
  static contextType = StateContext;
  render() {
    let bannerPadding = "";
    if (this.context.isBanner === true) {
      bannerPadding = "banner-padding-cookie"
    }
    else {
      bannerPadding = ""
    }
    return (
      <div className="main-section  main-body-bg">
        <div className={`${bannerPadding}`}>
          <div className="cookie-container">
            <h1 className="cookie-privacy-title h1-basic01 tc-head">Cookie Policy</h1>
            <br />
            <div>
              <p>
                This Cookie Policy explains how Kreditz uses cookies and similar technologies to recognize you when
                you visit our website at <a href="https://www.kreditz.com" target="_blank" rel="noopener noreferrer">www.kreditz.com</a>. It explains what these technologies are and why we use them,
                as well as your rights to control their use.
              </p>

              <h4>1. What are cookies?</h4>
              <p>
                Cookies are small text files that are stored on your device when you visit a website. They help websites
                remember your actions and preferences over time.
              </p>

              <h4>2. Types of cookies we use</h4>
              <p>
                We use both first-party and third-party cookies. Some are essential for the website to function properly,
                while others are used for analytics or marketing purposes.
              </p>

              <h4>3. How to control cookies</h4>
              <p>
                You can manage your cookie preferences through your browser settings. You can also withdraw your
                consent at any time by changing the settings in our cookie banner for optional cookies.
              </p>

              <h4>4. Processing of Personal Data</h4>
              <p>
                Some cookies on this website collect personal data, such as your IP address or device information. For
                more information about how we process personal data (including who the data controller is, the legal
                basis for processing, and your rights under the GDPR) please see our <Link to="/general-privacy-notice">Privacy Notice</Link>.
              </p>

              <h4>5. Updates to this Cookie Policy</h4>
              <p>
                We may update this Cookie Policy from time to time. Please review this policy regularly to stay informed
                about our use of cookies.
              </p>

              <h4>6. Cookies used on this site</h4>
              <p>
                Below is a list of the cookies we use, their purpose, and who is responsible for each cookie. For third-party cookies,
                the external provider acts as the data controller for the collection and processing of your
                data. For more information, please refer to the privacy or cookie policy of each provider.
              </p>
            </div>

            <div className='cookie-table'>
              <h3>Necessary</h3>
              <p>
                Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.
              </p>
              <table border="1">
                <thead>
                  <tr>
                    <th>Cookie Name</th>
                    <th>Category</th>
                    <th>Purpose</th>
                    <th>Duration</th>
                    <th>Controller</th>
                    <th>More Info</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>CookieConsent</td>
                    <td>Necessary</td>
                    <td>Stores the user's cookie consent state for the current domain</td>
                    <td>1 year</td>
                    <td>CookieConsent</td>
                    <td><a href="https://www.cookiebot.com/en/privacy-policy/" target="_blank">https://www.cookiebot.com/en/privacy-policy/</a></td>
                  </tr>
                  <tr>
                    <td>_GRECAPTCHA</td>
                    <td>Necessary</td>
                    <td>This cookie is used to distinguish between humans and bots. This is beneficial for the website, in order to make valid reports on the use of their website.</td>
                    <td>6 months</td>
                    <td>Google LLC</td>
                    <td><a href="https://business.safety.google/privacy/" target="_blank">https://business.safety.google/privacy/</a></td>
                  </tr>
                  <tr>
                    <td>rc::a</td>
                    <td>Necessary</td>
                    <td>This cookie is used to distinguish between humans and bots. This is beneficial for the website, in order to make valid reports on the use of their website.</td>
                    <td>Persistent</td>
                    <td>Google LLC</td>
                    <td><a href="https://business.safety.google/privacy/" target="_blank">https://business.safety.google/privacy/</a></td>
                  </tr>
                  <tr>
                    <td>rc::b</td>
                    <td>Necessary</td>
                    <td>This cookie is used to distinguish between humans and bots.</td>
                    <td>Session</td>
                    <td>Google LLC</td>
                    <td><a href="https://business.safety.google/privacy/" target="_blank">https://business.safety.google/privacy/</a></td>
                  </tr>
                  <tr>
                    <td>rc::c</td>
                    <td>Necessary</td>
                    <td>This cookie is used to distinguish between humans and bots.</td>
                    <td>Session</td>
                    <td>Google LLC</td>
                    <td><a href="https://business.safety.google/privacy/" target="_blank">https://business.safety.google/privacy/</a></td>
                  </tr>
                  <tr>
                    <td>rc::f</td>
                    <td>Necessary</td>
                    <td>This cookie is used to distinguish between humans and bots.</td>
                    <td>Persistent</td>
                    <td>Google LLC</td>
                    <td><a href="https://business.safety.google/privacy/" target="_blank">https://business.safety.google/privacy/</a></td>
                  </tr>
                  <tr>
                    <td>_cfuvid [x2]</td>
                    <td>Necessary</td>
                    <td>This cookie is a part of the services provided by Cloudflare - Including load-balancing, deliverance of website content and serving DNS connection for website operators.</td>
                    <td>Session</td>
                    <td>Cloudflare</td>
                    <td><a href="https://www.cloudflare.com/privacypolicy/" target="_blank">https://www.cloudflare.com/privacypolicy/</a></td>
                  </tr>
                  <tr>
                    <td>bcookie</td>
                    <td>Necessary</td>
                    <td>Used in order to detect spam and improve the website's security.</td>
                    <td>1 year</td>
                    <td>LinkedIn</td>
                    <td><a href="https://www.linkedin.com/legal/privacy-policy" target="_blank">https://www.linkedin.com/legal/privacy-policy</a></td>
                  </tr>
                  <tr>
                    <td>li_gc</td>
                    <td>Necessary</td>
                    <td>Stores the user's cookie consent state for the current domain</td>
                    <td>6 months</td>
                    <td>LinkedIn</td>
                    <td><a href="https://www.linkedin.com/legal/privacy-policy" target="_blank">https://www.linkedin.com/legal/privacy-policy</a></td>
                  </tr>
                  <tr>
                    <td>__cf_bm [x10]</td>
                    <td>Necessary</td>
                    <td>This cookie is used to distinguish between humans and bots. This is beneficial for the website, in order to make valid reports on the use of their website.</td>
                    <td>1 day</td>
                    <td>hsadspixel.net, hs-banner.com, hubspotusercontent-na1.net</td>
                    <td><a href="https://legal.hubspot.com/cookie-policy" target="_blank">https://legal.hubspot.com/cookie-policy</a></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className='cookie-table'>
              <h3>Preferences</h3>
              <p>
                Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.
              </p>
              <table border="1">
                <thead>
                  <tr>
                    <th>Cookie Name</th>
                    <th>Category</th>
                    <th>Purpose</th>
                    <th>Duration</th>
                    <th>Controller</th>
                    <th>More Info</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>lidc</td>
                    <td>Preferences</td>
                    <td>Registers which server-cluster is serving the visitor. This is used in context with load balancing, in order to optimize user experience.</td>
                    <td>1 day</td>
                    <td>LinkedIn Corporation</td>
                    <td><a href="https://www.linkedin.com/legal/cookie-policy" target="_blank">https://www.linkedin.com/legal/cookie-policy</a></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className='cookie-table'>
              <h3>Statistics</h3>
              <p>
                Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.
              </p>
              <table border="1">
                <thead>
                  <tr>
                    <th>Cookie Name</th>
                    <th>Category</th>
                    <th>Purpose</th>
                    <th>Duration</th>
                    <th>Controller</th>
                    <th>More Info</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>hjActiveViewportIds</td>
                    <td>Statistics</td>
                    <td>This cookie contains an ID string on the current session. This contains non-personal information on what subpages the visitor enters – this information is used to optimize the visitor's experience.</td>
                    <td>Persistent</td>
                    <td>Hotjar Ltd.</td>
                    <td><a href="https://help.hotjar.com/hc/en-us/articles/6952777582999-Cookies-Set-by-the-Hotjar-Tracking-Code" target="_blank">https://help.hotjar.com/hc/en-us/articles/6952777582999-Cookies-Set-by-the-Hotjar-Tracking-Code</a></td>
                  </tr>
                  <tr>
                    <td>hjViewportId</td>
                    <td>Statistics</td>
                    <td>Saves the user's screen size in order to adjust the size of images on the website.</td>
                    <td>Session</td>
                    <td>Hotjar Ltd.</td>
                    <td><a href="https://help.hotjar.com/hc/en-us/articles/6952777582999-Cookies-Set-by-the-Hotjar-Tracking-Code" target="_blank">https://help.hotjar.com/hc/en-us/articles/6952777582999-Cookies-Set-by-the-Hotjar-Tracking-Code</a></td>
                  </tr>
                  <tr>
                    <td>_hjCookieTest</td>
                    <td>Statistics</td>
                    <td>Collects data on the user’s navigation and behavior on the website. This is used to compile statistical reports and heatmaps for the website owner.</td>
                    <td>Session</td>
                    <td>Hotjar Ltd.</td>
                    <td><a href="https://help.hotjar.com/hc/en-us/articles/6952777582999-Cookies-Set-by-the-Hotjar-Tracking-Code" target="_blank">https://help.hotjar.com/hc/en-us/articles/6952777582999-Cookies-Set-by-the-Hotjar-Tracking-Code</a></td>
                  </tr>
                  <tr>
                    <td>_hjSession_#</td>
                    <td>Statistics</td>
                    <td>Collects statistics on the visitor's visits to the website, such as the number of visits, average time spent on the website and what pages have been read.</td>
                    <td>1 day</td>
                    <td>Hotjar Ltd.</td>
                    <td><a href="https://help.hotjar.com/hc/en-us/articles/6952777582999-Cookies-Set-by-the-Hotjar-Tracking-Code" target="_blank">https://help.hotjar.com/hc/en-us/articles/6952777582999-Cookies-Set-by-the-Hotjar-Tracking-Code</a></td>
                  </tr>
                  <tr>
                    <td>_hjSessionUser_#</td>
                    <td>Statistics</td>
                    <td>Collects statistics on the visitor's visits to the website, such as the number of visits, average time spent on the website and what pages have been read.</td>
                    <td>1 year</td>
                    <td>Hotjar Ltd.</td>
                    <td><a href="https://help.hotjar.com/hc/en-us/articles/6952777582999-Cookies-Set-by-the-Hotjar-Tracking-Code" target="_blank">https://help.hotjar.com/hc/en-us/articles/6952777582999-Cookies-Set-by-the-Hotjar-Tracking-Code</a></td>
                  </tr>
                  <tr>
                    <td>__hssc</td>
                    <td>Statistics</td>
                    <td>Identifies if the cookie data needs to be updated in the visitor's browser.</td>
                    <td>1 day</td>
                    <td>HubSpot Inc.</td>
                    <td><a href="https://legal.hubspot.com/cookie-policy" target="_blank">https://legal.hubspot.com/cookie-policy</a></td>
                  </tr>
                  <tr>
                    <td>__hssrc</td>
                    <td>Statistics</td>
                    <td>Used to recognise the visitor's browser upon reentry on the website.</td>
                    <td>Session</td>
                    <td>HubSpot Inc.</td>
                    <td><a href="https://legal.hubspot.com/cookie-policy" target="_blank">https://legal.hubspot.com/cookie-policy</a></td>
                  </tr>
                  <tr>
                    <td>__hstc</td>
                    <td>Statistics</td>
                    <td>Sets a unique ID for the session. This allows the website to obtain data on visitor behaviour for statistical purposes.</td>
                    <td>6 months</td>
                    <td>HubSpot Inc.</td>
                    <td><a href="https://legal.hubspot.com/cookie-policy" target="_blank">https://legal.hubspot.com/cookie-policy</a></td>
                  </tr>
                  <tr>
                    <td>hubspotutk</td>
                    <td>Statistics</td>
                    <td>Sets a unique ID for the session. This allows the website to obtain data on visitor behaviour for statistical purposes.</td>
                    <td>6 months</td>
                    <td>HubSpot Inc.</td>
                    <td><a href="https://legal.hubspot.com/cookie-policy" target="_blank">https://legal.hubspot.com/cookie-policy</a></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className='cookie-table'>
              <h3>Marketing</h3>
              <p>
                Marketing cookies are used to track visitors across the website. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.
              </p>
              <table border="1">
                <thead>
                  <tr>
                    <th>Cookie Name</th>
                    <th>Category</th>
                    <th>Purpose</th>
                    <th>Duration</th>
                    <th>Controller</th>
                    <th>More Info</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>__ptq.gif</td>
                    <td>Marketing</td>
                    <td>Sends data to the marketing platform Hubspot about the visitor's device and behaviour. Tracks the visitor across devices and marketing channels.</td>
                    <td>Session</td>
                    <td>HubSpot Inc.</td>
                    <td><a href="https://legal.hubspot.com/cookie-policy" target="_blank">https://legal.hubspot.com/cookie-policy</a></td>
                  </tr>
                  <tr>
                    <td>viral-links/v1/tracking</td>
                    <td>Marketing</td>
                    <td>Tracks the individual sessions on the website, allowing the website to compile statistical data from multiple visits. This data can also be used to create leads for marketing purposes.</td>
                    <td>Session</td>
                    <td>HubSpot Inc.</td>
                    <td><a href="https://legal.hubspot.com/cookie-policy" target="_blank">https://legal.hubspot.com/cookie-policy</a></td>
                  </tr>
                  <tr>
                    <td>__hmpl</td>
                    <td>Marketing</td>
                    <td>Collects information on user preferences and/or interaction with web-campaign content - This is used on CRM-campaign-platform used by website owners for promoting events or products.</td>
                    <td>Session</td>
                    <td>HubSpot Inc.</td>
                    <td><a href="https://legal.hubspot.com/cookie-policy" target="_blank">https://legal.hubspot.com/cookie-policy</a></td>
                  </tr>
                  <tr>
                    <td>HUBLYTICS_EVENTS_53</td>
                    <td>Marketing</td>
                    <td>Collects data on visitor behaviour from multiple websites, in order to present more relevant advertisements. This also allows the website to limit the number of times that they are shown the same advertisement.</td>
                    <td>Session</td>
                    <td>HubSpot Inc.</td>
                    <td><a href="https://legal.hubspot.com/cookie-policy" target="_blank">https://legal.hubspot.com/cookie-policy</a></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Cookie;